import '../features/footerMenuAccordion/scripts/';
import '../features/productCard/scripts/';
import '../features/quickLinksAndDesc/scripts/';
import '../features/collectionCampaign/scripts/';

import '../features/bedConfigurator/scripts/';

import '../features/sizeFilter/scripts';
import '../features/trustPilot/scripts';
import '../features/cartDrawer/scripts';
import '../features/connectedProducts/scripts';
import '../features/pageNavigation/scripts';
import '../features/cartGlobalScripts/scripts';
import '../features/imageWithText/scripts';
import '../features/quiz/scripts';
